<div class="dates">
  <div class="date">
    <mat-form-field appearance="outline">
      <mat-label>Data inicial</mat-label>
      <input
        matInput
        type="date"
        [(ngModel)]="selected"
        (ngModelChange)="formatData()"
        [disabled]="disabled()"
      />
      <mat-icon matSuffix>event</mat-icon>
      <mat-hint>DD/MM/YYYY</mat-hint>
    </mat-form-field>
    <mat-calendar
      [ngClass]="{ disabled: disabled() }"
      #calendarStartDate
      [startAt]="startDate()"
      [(selected)]="startDate"
      (selectedChange)="selectDate()"
      [maxDate]="maxDate"
    ></mat-calendar>
  </div>
  <div class="date">
    <mat-form-field appearance="outline">
      <mat-label>Data final</mat-label>
      <input
        matInput
        type="date"
        [(ngModel)]="selected2"
        (ngModelChange)="formatData()"
        [disabled]="disabled()"
      />
      <mat-icon matSuffix>event</mat-icon>
      <mat-hint>DD/MM/YYYY</mat-hint>
    </mat-form-field>
    <mat-calendar
      [ngClass]="{ disabled: disabled() }"
      #calendarEndDate
      [startAt]="endDate()"
      [(selected)]="endDate"
      (selectedChange)="selectDate()"
      [maxDate]="maxDate"
    ></mat-calendar>
  </div>
</div>
